import React, { useState, useEffect } from "react";
import { loc } from "./Helpers/Localizations"
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import { NormalDialogContent, NormalDialogTitle } from "./Helpers/DialogStyleHelper";
import copy from "copy-to-clipboard";  
 
export default function Results() {

  const [results, setResults] = useState(null);
  const [competition, setCompetition] = useState({Competition: '', Date: null, Course: ''});
  const [showCopyDialog, setShowCopyDialog] = useState(false);

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  useEffect(() => {
   const results = localStorage.getItem("metrixResult");

  if (results == null) {
    return;
  }

   const resultJson = JSON.parse(results);
   if (resultJson['Competition']) {
     const dateTime = resultJson['Competition']['Date'] + " " + resultJson['Competition']['Time'];
     setCompetition({
       Competition: resultJson['Competition']['Name'].indexOf('&rarr') > 0 ? resultJson['Competition']['Name'].split('&rarr')[0] : resultJson['Competition']['Name'],
       Date: new Date(dateTime).toLocaleString(),
       Course: resultJson['Competition']['CourseName']
     })
   } 
  
   setResults(resultJson);

   setShowCopyDialog(false);
  }, []);

  function copyToClipboard(e) {
    e.stopPropagation();
    e.preventDefault();

    setShowCopyDialog(true);
  }

  function copyDefaultToClipBoard(e) {
    e.stopPropagation();
    e.preventDefault();

    setShowCopyDialog(false);

    copy(getDefaultResult());
  }

  function getDefaultResult() {
    if (!results || !results.Competition || !results.Competition.Results || !competition || results.Competition.Results.length === 0) {
      // Multi-round
      if (results && results.Competition && results.Competition.SubCompetitions && competition && results.Competition.SubCompetitions.length > 0) return getDefaultMultiRoundResult();
      
      // Multi-pool
      if (results && results.Competition && results.Competition.TourResults && competition && results.Competition.TourResults.length > 0) return getDefaultMultiPoolResult();
    }

    const line = '\n ----------- \n';
    let defaultResults = competition['Competition'] + '\n' + results.Competition.CourseName.replace('&rarr;', '') + '\n' + competition['Date'];
    defaultResults += line;

    if (results.Competition.WeeklyHC != null && results.Competition.WeeklyHC.length) {
      defaultResults+= '\n\n Tasoituskilpailu:'
      defaultResults += line;

      results.Competition.WeeklyHC
        .forEach(function(item, index, array) {

        if (item.Rating == null || item.Rating === '' || item.Rating === 0) {
          defaultResults = `${defaultResults}${item.Order}) ${item.Name} (ei tasoitusta) `;
        } else {
          defaultResults = `${defaultResults}${item.Order}) ${item.Name} ${parseFloat(item.Change).toFixed(2)} (tasoitus ${parseFloat(item.HC).toFixed(2)}`

          if (index === array.length - 1) defaultResults += ')';
          else defaultResults += '), ';
        }
      });
    }

    let competitionClass = '';
    const lineBreak = '\n \n';

    if (results.Competition.Results != null && results.Competition.Results.length) {
      defaultResults+= '\n\n Tuloskilpailu:';
      defaultResults += line;

      results.Competition.Results
        .forEach(function(item, index, array) {

        let dnf = item.DNF != null;

        let changeOfClass = competitionClass !== item.ClassName;
        competitionClass = item.ClassName;

        if (changeOfClass) {
          if (defaultResults.slice(defaultResults.length - 2, defaultResults.length) === ', ') defaultResults = defaultResults.slice(0, defaultResults.length - 2);
          if (index !== 0) defaultResults += lineBreak;
          defaultResults = `${defaultResults}${competitionClass}`;
          defaultResults += line;
        }

        if (dnf) {
          defaultResults = `${defaultResults}${item.Name} DNF`;
        } else {
          defaultResults = `${defaultResults}${item.OrderNumber ?? '1'}) ${item.Name} ${item.Sum} (${item.Diff > 0 ? '+' : ''}${item.Diff}`

          if (index === array.length - 1) defaultResults += ')';
          else defaultResults += '), ';
        }
      });
    }

    return defaultResults + line;
  }

  function getDefaultMultiRoundResult() {
    if (!results || !results.Competition || !results.Competition.SubCompetitions || !competition || results.Competition.SubCompetitions.length === 0) return null;

    const line = '\n ----------- \n';
    const lineBreak = '\n \n';
    let defaultResults = competition['Competition'] + '\n' + results.Competition.CourseName.replace('&rarr;', '') + '\n' + competition['Date'];
    defaultResults += line;

    const lastRound = results.Competition.SubCompetitions[results.Competition.SubCompetitions.length - 1];
    let competitionClass = '';
    if (lastRound.Results && lastRound.Results.length) {
      lastRound.Results
        .forEach(function(item, index, array) {

        let dnf = item.DNF != null && item.DNF !== '0';

        let changeOfClass = competitionClass !== item.ClassName;
        competitionClass = item.ClassName;

        if (changeOfClass) {
          if (defaultResults.slice(defaultResults.length - 2, defaultResults.length) === ', ') defaultResults = defaultResults.slice(0, defaultResults.length - 2);
          if (index !== 0) defaultResults += lineBreak;
          defaultResults = `${defaultResults}${competitionClass}`;
          defaultResults += line;
        }

        if (dnf) {
          defaultResults = `${defaultResults}${item.Name} DNF `;
        } else {
          defaultResults = `${defaultResults}${item.OrderNumber ?? '1'}) ${item.Name} ${item.PreviousRoundsSum} (${item.PreviousRoundsDiff > 0 ? '+' : ''}${item.PreviousRoundsDiff}`

          if (index === array.length - 1) defaultResults += ')';
          else defaultResults += '), ';
        }
      });
    }

    return defaultResults + line;
  }

  function getDefaultMultiPoolResult() {
    if (!results || !results.Competition || !results.Competition.TourResults || !competition || results.Competition.TourResults.length === 0) return null;

    const line = '\n ----------- \n';
    const lineBreak = '\n \n';
    let defaultResults = competition['Competition'] + '\n' + competition['Date'];
    defaultResults += line;

    let competitionClass = '';
    if (results.Competition.TourResults && results.Competition.TourResults.length) {
      results.Competition.TourResults
        .forEach(function(item, index, array) {

        let dnf = item.DNF != null && item.DNF !== '0';

        let changeOfClass = competitionClass !== item.ClassName;
        competitionClass = item.ClassName;

        if (changeOfClass) {
          if (defaultResults.slice(defaultResults.length - 2, defaultResults.length) === ', ') defaultResults = defaultResults.slice(0, defaultResults.length - 2);
          if (index !== 0) defaultResults += lineBreak;
          defaultResults = `${defaultResults}${competitionClass}`;
          defaultResults += line;
        }

        if (dnf) {
          defaultResults = `${defaultResults}${item.Name} DNF`;
        } else {
          defaultResults = `${defaultResults}${item.Place}) ${item.Name} ${item.Total}`

          if (index === array.length - 1) defaultResults += '';
          else defaultResults += ', ';
        }
      });
    }

    return defaultResults + line;
  }

  function closeDialog() {
    setShowCopyDialog(false);
  }

  function renderHCResults() {
    if (!results || !results.Competition || !results.Competition.WeeklyHC || !competition) return null;

    return results.Competition.WeeklyHC
      .map((x, i) => {
        if (x.Rating == null || x.Rating === '' || x.Rating === 0) { 
          return (
            <div key={i}>
              {i === 0 ? <div>Tasoituskilpailu:</div> : ''}
              {x.Order}{')'} {x.Name} {'(ei tasoitusta)'}
            </div>
          )
        }

        return (
          <div key={i}>
            {i === 0 ? <div>Tasoituskilpailu:</div> : ''}
            { x.Order}{')'} {x.Name} {parseFloat(x.Change).toFixed(2)} {'(tasoitus '}{parseFloat(x.HC).toFixed(2)}{')'}
          </div>
        )
      });
  }

  function renderResults() {
    if (!results || !results.Competition || !results.Competition.Results || !competition || results.Competition.Results.length === 0) {
      // Multiround:
      if (results && results.Competition && competition && results.Competition.SubCompetitions && results.Competition.SubCompetitions.length > 0) return renderMultiRoundResults();

      // Multiple pools
      else if (results && results.Competition && competition && results.Competition.TourResults && results.Competition.TourResults.length > 0) return renderMultiPoolResults();
      
      else return null;
    }

    let competitionClass = '';

    return results.Competition.Results
      .map((x, i) => {
        let dnf = x.DNF != null && x.DNF !== '0';


        let changeOfClass = competitionClass !== x.ClassName;
        competitionClass = x.ClassName;

        if (dnf) {
          return (
            <div key={i}>
              {i === 0 ? <div>Tuloskilpailu::</div> : ''}
              {changeOfClass ? <div>{competitionClass}:</div> : ''}
              {x.Name} DNF
            </div>
          )
        }

        return (
          <div key={i}>
            {i === 0 ? <div>Tuloskilpailu:</div> : ''}
            {changeOfClass ? <div>{competitionClass}:</div> : ''}
            {x.OrderNumber ?? '1'}{')'} {x.Name} {x.Sum} {'('}{x.Diff > 0 ? '+' : ''}{x.Diff}{')'}
          </div>
        )
    });
  }

  function renderMultiRoundResults() {
    if (!results || !results.Competition || !competition || !results.Competition.SubCompetitions || results.Competition.SubCompetitions.length === 0) return null;

    const lastRound = results.Competition.SubCompetitions[results.Competition.SubCompetitions.length - 1];
    let competitionClass = '';
    return lastRound.Results // last round should be checked
      .map((x, i) => {
        let dnf = x.DNF != null && x.DNF !== '0';

        let changeOfClass = competitionClass !== x.ClassName;
        competitionClass = x.ClassName;

        if (dnf) {
          return (
            <div key={i}>
              {changeOfClass ? <div>{competitionClass}:</div> : ''}
              {i === 0 ? <div>Tuloskilpailu:</div> : ''}
              {x.Name} DNF
            </div>
          )
        }

        return (
          <div key={i}>
            {changeOfClass ? <div>{competitionClass}:</div> : ''}
            {x.OrderNumber ?? '1'}{')'} {x.Name} {x.PreviousRoundsSum} {'('}{x.PreviousRoundsDiff > 0 ? '+' : ''}{x.PreviousRoundsDiff}{')'}
          </div>
        )
    });
  }

  function renderMultiPoolResults() {
    if (!results || !results.Competition || !competition || !results.Competition.TourResults || results.Competition.TourResults.length === 0) return null;

    let competitionClass = '';
    return results.Competition.TourResults
      .map((x, i) => {
        let dnf = x.DNF != null && x.DNF !== '0';

        let changeOfClass = competitionClass !== x.ClassName;
        competitionClass = x.ClassName;

        if (dnf) {
          return (
            <div key={i}>
              {changeOfClass ? <div>{competitionClass}:</div> : ''}
              {i === 0 ? <div>Tuloskilpailu:</div> : ''}
              {x.Name} DNF
            </div>
          )
        }

        return (
          <div key={i}>
            {changeOfClass ? <div>{competitionClass}:</div> : ''}
            {x.Place}{')'} {x.Name} {x.Total}
          </div>
        )
    });
  }

  function showDialog() {
    if (!showCopyDialog) return null;

    return (
      <Dialog
        open={showCopyDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NormalDialogTitle id="alert-dialog-title">{loc('Select copy format')}</NormalDialogTitle>
        <NormalDialogContent>
          <Button onClick={copyDefaultToClipBoard} color="primary" class="border-2 border-blue-400 bg-blue-600 mr-8">{loc("DEFAULT")}</Button>
          <Button color="primary" class="border-2 border-blue-400 bg-blue-600">{loc("CUSTOM")}</Button>
        </NormalDialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()} color="primary" autoFocus>
            {loc("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <div class="flex items-center justify-center h-screen w-12/12 mt-10">
      <div class="bg-gray-100 font-bold rounded-lg border shadow-lg p-10 opacity-50 h-auto max-h-full overflow-scroll">
        <button class="justify-end p-2 w-12/12 text-white bg-gray-900 rounded-lg border shadow-lg opacity-100"
                        type="submit" onClick={copyToClipboard}>Copy to clipboard</button>
        <h1>{competition['Competition']}</h1>
        <h2>{competition['Date']}</h2>
        <br/>
        {renderHCResults()}
        <br/>
        {renderResults()}
        {showDialog()}
      </div>
    </div>
  );  
}